$(document).ready(function () {

	$(document).on('change', '.select_data_people', function () {
        var type_people = document.getElementById('select_type_people').value;
        var group_people = document.getElementById('select_group_people').value;
        var position_people = document.getElementById('select_position_people').value;
        var person = document.getElementById('person_fio').value;

        var table_peoples_block = document.getElementById('table_peoples'); 
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

        $.ajax({    
            url: '/peoplestable',   
            type: 'POST', 
            data: {
                _token:CSRF_TOKEN,
                type:'getpeoples',
                typep:type_people,
                group:group_people,
                position:position_people,
                person:person},  
            dataType: 'JSON',
            success: function (data) {
                table_peoples_block.innerHTML = "";
                data.users.forEach(function(user) {
                    table_peoples_block.insertAdjacentHTML('beforeend',
                        "<tr><td class='text-center'>"+user.id+"</td>"+
                        "<td class='text-center'>"+user.name+"</td>"+
                        "<td class='text-center'>"+user.type+"</td>"+ 
                        "<td class='text-center'>-</td>"+ 
                        "<td class='text-center'>"+user.position+"</td>"+
                        "<td class='text-center'><a class='settings_people btn btn-primary btn-xs' people_id='"+user.id+"' data-target='#settings_people' data-toggle='modal'><b style='color: white'>Подробнее</b></a></td>"+
                        "</tr>");
                });
            }

        });
    });

    $(document).on('input', '.select_controls_persons', function () {
        var requests4services_id =  window.location.href.split('/').pop();
        var person_fio = document.getElementById('filter_control_persons').value;
        var status = document.getElementById('select_control_persons').value;
        var login = document.getElementById('select_control_login').value;

        // alert(requests4services_id);

        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

        $.get('getPersonsControlFilter', {id: requests4services_id, person_fio: person_fio, login: login, status: status}, function (data) {
           $('.control_persons').html(data); 
       });
    });

    $(document).on('input', '.select_persons4services', function () {
        var requests4services_id = sessionStorage.getItem('requests4services_id');
        var person_fio = document.getElementById('filter_persons4services').value;
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

        $.get('getPersonsServicesFilter', {id: requests4services_id, person_fio: person_fio, _token: CSRF_TOKEN}, function (data) {
           $('#persons4services').html(data); 
       });
    });

    $(document).on('input', '.select_persons4servicespass', function () {
        var requests4services_id = sessionStorage.getItem('requests4services_id');
        var person_fio = document.getElementById('filter_persons4servicespass').value;
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

        $.get('getPersonsServicesPassFilter', {id: requests4services_id, person_fio: person_fio, _token: CSRF_TOKEN}, function (data) {
           $('#persons4servicespass').html(data); 
       });
    });

    $(document).on('input', '.select_persons4servicesalerts', function () {
        var requests4services_id = sessionStorage.getItem('requests4services_id');
        var person_fio = document.getElementById('filter_persons4servicesalerts').value;
        var person_status = document.getElementById('filter_persons4servicesalerts_status').value;
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

        $.get('getPersonsServicesAlertsFilter', {id: requests4services_id, person_fio: person_fio,person_status:person_status, _token: CSRF_TOKEN}, function (data) {
           $('#persons4servicesalerts').html(data); 
       });
    });

    $(document).on('input', '.select_students_cerf_stat', function () {
        var person_fio = document.getElementById('filter_students_cerf_stat').value;
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
        var view = 'certificate_students_stat'


        $.get('statisticstable', {fio: person_fio, view:view, _token: CSRF_TOKEN}, function (data) {
           $('#table_statistic_serf').html(data);
       });
    });

    $(document).on('input', '.select_person_serf', function () {
        var person_fio = document.getElementById('filter_person_serf').value;
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');



        $.get('getpersonsserf', {fio: person_fio, _token: CSRF_TOKEN}, function (data) {
           $('#table_person_cerf').html(data);
       });
    });

    $(document).on('input', '.select_data_person', function () {
        var type_people = document.getElementById('select_type_people').value;
        var group_people = document.getElementById('select_group_people').value;
        var position_people = document.getElementById('select_position_people').value;
        var person = document.getElementById('person_fio').value;

        var table_peoples_block = document.getElementById('table_peoples'); 
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

        $.ajax({    
            url: '/peoplestable',   
            type: 'POST', 
            data: {
                _token:CSRF_TOKEN,
                type:'getpeoples',
                typep:type_people,
                group:group_people,
                position:position_people,
                person:person},  
            dataType: 'JSON',
            success: function (data) {
                table_peoples_block.innerHTML = "";
                data.users.forEach(function(user) {
                    table_peoples_block.insertAdjacentHTML('beforeend',
                        "<tr><td class='text-center'>"+user.id+"</td>"+
                        "<td class='text-center'>"+user.name+"</td>"+
                        "<td class='text-center'>"+user.type+"</td>"+ 
                        "<td class='text-center'>-</td>"+ 
                        "<td class='text-center'>"+user.position+"</td>"+
                        "<td class='text-center'><a class='settings_people btn btn-primary btn-xs' people_id='"+user.id+"' data-target='#settings_people' data-toggle='modal'><b style='color: white'>Подробнее</b></a></td>"+
                        "</tr>");
                });
            }


        });
    });

    $(document).on('input', '.select_students_cerf', function () {
        var person_fio = document.getElementById('filter_students_cerf').value;

        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

        var location = window.location.href;

        var id = location.split('/').pop();

        if(location.indexOf('services') != -1) {
            var type = 'services';
        } else {
            var type = 'requests';
        }



        var table_students_block = document.getElementById('table_studets_cerf'); 

        $.ajax({    
            url: '/studentstablecerf',   
            type: 'POST', 
            data: {
                _token:CSRF_TOKEN,
                person_fio: person_fio,
                id: id,
                type: type},  
            dataType: 'JSON',
            success: function (data) {
                table_students_block.innerHTML = "";
                data.students.forEach(function(student) {
                    table_students_block.insertAdjacentHTML('beforeend',
                        "<tr class='table_row'><td class='text-center'>"+student.fio+"</td>"+
                        "<td class='text-center'>"+student.protocol+"</td>"+
                        "<td class='text-center'>"+student.certificate+"</td>"+
                        "<td class='text-center'>"+student.protocol_date+"</td>"+
                        "<td class='text-center'>"+student.validity_end+"</td>"+
                        "<td class='text-center'><a href='/../../generatecerfpid/udo/"+student.id+"' id ="+student.id+" class='btn btn-primary btn-xs cerf_btn' target='_blank' style='color: #fff;'>Скачать</a></td>"+          
                        "</tr>");
                });
                
            }
        });
    });

    $(document).on('input', '.select_data_orders', function () {
        var type_payment = document.getElementById('select_type_payment').value;
        var type_status = document.getElementById('select_type_status').value;
        var filter_all = document.getElementById('filter_all').value;


        var table_orders_block = document.getElementById('table_orders'); 
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');

        $.ajax({    
            url: '/orderstable',   
            type: 'POST', 
            data: {
                _token:CSRF_TOKEN,
                type:'getorders',
                typep:type_payment,
                types:type_status,
                filter:filter_all}, 
            dataType: 'JSON',
            success: function (data) {
                table_orders_block.innerHTML = "";
                data.orders.forEach(function(order) {
                    if(order.pays == 'Не оплачена'){
                        var colorstatus = 'badge-warning';
                    }else{
                        var colorstatus = 'badge-success';
                    }
                    table_orders_block.insertAdjacentHTML('beforeend',
                        "<tr><td class='text-center'>"+order.date+"</td>"+
                        "<td class='text-center'>"+order.req_num+"</td>"+ 
                        "<td class='text-left'>"+order.paytype+"</td>"+ 
                        "<td class='text-center'>"+order.count+"</td>"+
                        "<td class='text-left'>"+order.status+"</td>"+
                        "<td class='text-center'>"+order.money+" руб.</td>"+
                        "<td class='text-center'>"+"<span class='badge badge-table "+colorstatus+"'>"+order.pays+"</span></td>"+
                        "<td class='text-center'>"+"<a id='uslugi' href='' class='btn btn-primary btn-xs submit_order' aria-controls='exampleTopComponents' role='tab' order_id = "+order.id+"><b style='color: white'>Подробнее</b></a></td>"+
                        "</tr>");
                });
            }


        });
    });

    $(document).on('input', '.select_data_services', function () {
        var service_status = document.getElementById('select_service_status').value;
        var filter_request = document.getElementById('filter_request').value;
        var service_edutype = document.getElementById('select_service_edutype').value;  
        var department = document.getElementById('filter_department').value;  
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');


        $.get('/servicestable', {_token: CSRF_TOKEN, status:service_status, filter_:filter_request, edutype:service_edutype, did:department}, function (data) {
           $('#table_services').html(data); 
        });
    });

    $(document).on('click', '.submit_order1', function () {
        var order_id = this.getAttribute('order_id');
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
        var requests4services_table = document.getElementById('requests4services_table');
        //  window.location.assign("/message?_token="+CSRF_TOKEN+"&type=check&chatid="+chat_id);
        $.ajax({
            url: '/orderajax',
            type: 'GET',
            data: {_token: CSRF_TOKEN, order_id: order_id, type:'requests4services'},
            dataType: 'JSON',
            success: function (data) {
                if(data.status == 'success'){
                    requests4services_table.innerHTML = "";
                    data.orders.forEach(function(order) {
                        requests4services_table.insertAdjacentHTML('beforeend',
                        "<tr class='table_row'><td class='text-center'>"+order.id+"</td>"+
                        "<td class='text-left'>"+order.name+"</td>"+
                        "<td class='text-left'>"+order.expert+"</td>"+
                        "<td class='text-center'>"+order.count+"</td>"+
                        "<td class='text-left'>"+order.direction+"</td>"+
                        "<td class='text-left'>"+order.type_edu+"</td>"+
                        "<td class='text-center'><a id='uslugi' href='#' class='btn btn-primary btn-xs' r4s_id = '"+order.id+"'>"+
                        "<b style='color: white'>Подробнее</b></a></td></tr>");
                    });
                }
            }
        });
    });

    $(document).on('click', '.submit_order_persons', function () {
        var tableblock = document.getElementById('requests4services_table');
        var order_id = this.getAttribute('order_id');
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
        $.ajax({
            url: '/orderajax', 
            type: 'GET',
            data: {_token: CSRF_TOKEN, order_id: order_id, type:'order'},
            dataType: 'JSON',
            success: function (data) {
                 // alert(order_id);
                
                if(data.status == 'success'){
                    tableblock.innerHTML = "";
                    data.orders.forEach(function(order) {
                        tableblock.insertAdjacentHTML('beforeend',
                            " <tr class=\"table_row\"><td class=\"text-center\">"+order.id+"</td>"+
                            "<td class=\"text-left\">"+order.name+"</td>"+
                            "<td class=\"text-center\">"+order.expert+"</td>"+
                            "<td class=\"text-center\">"+order.count+"</td>"+
                            "<td class=\"text-center\">Первичная</td>"+
                            "<td class=\"text-center\">"+order.direction +"</td>"+
                            "<td class=\"text-center\"><a id=\"req_num\" href=\"#\" class=\"btn btn-primary btn-xs\">"+
                            "<b style=\"color: white\">Добавить учащихся</b></a></td></tr>");
                    });
                }
            }
        });
    });


    $(document).on('click', '.submit_order', function () {
        var tableblock = document.getElementById('requests4services_table');
        var order_id = this.getAttribute('order_id');
        var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
        $.ajax({
            url: '/orderajax', 
            type: 'GET',
            data: {_token: CSRF_TOKEN, order_id: order_id, type:'order'},
            dataType: 'JSON',
            success: function (data) {
                 // alert(order_id);
                
                if(data.status == 'success'){
                    tableblock.innerHTML = "";
                    data.orders.forEach(function(order) {
                        tableblock.insertAdjacentHTML('beforeend',
                            " <tr class=\"table_row\"><td class=\"text-center\">"+order.id+"</td>"+
                            "<td class=\"text-left\">"+order.name+"</td>"+
                            "<td class=\"text-center\">"+order.expert+"</td>"+
                            "<td class=\"text-center\">"+order.count+"</td>"+
                            "<td class=\"text-center\">Первичная</td>"+
                            "<td class=\"text-center\">"+order.direction +"</td>"+
                            "<td class=\"text-center\"><a id=\"req_num\" href=\"#\" class=\"btn btn-primary btn-xs\">"+
                            "<b style=\"color: white\">Добавить учащихся</b></a></td></tr>");
                    });
                }
            }
        });
    });


    $(document).on('input', '.select_data_controls', function () {
        var controle_status = document.getElementById('select_control_status').value;
        var filter_controle = document.getElementById('filter_control').value;
        var select_control_type = document.getElementById('select_control_type').value;



        $.get('/controlstable', {status:controle_status, filter:filter_controle, type: select_control_type}, function (data) {
           $('#table_controls').html(data); 
        });

    });

    $(document).on('input', '.select_data_groups', function () {
        var controle_status = document.getElementById('select_group_status').value;
        var edutype = document.getElementById('select_groups_edutype').value;



        $.get('/groupstable', {status:controle_status, edutype:edutype}, function (data) {
           $('#table_groups').html(data); 
        });

    });
});